'use client'
import { PortableText, PortableTextComponents, SanityAssetDocument } from 'next-sanity'
import { styles, SingleImageVariants } from './SingleImage.css'
import { SanityImage } from '../SanityImage'
import { PortableTextObject } from 'sanity'
import { AppText } from '../AppText'
import { Button } from '../Button'
import { DownloadIcon } from '@otomoro/components/icons/Download'
import { useState } from 'react'
import { PopupForm } from '../PopupForm'
import { SectionHeader } from "../SectionHeader"
import clsx from 'clsx'
import { usePathname } from 'next/navigation'

interface SingleImageProps extends SingleImageVariants {
  image: SanityAssetDocument
  displayText: boolean
  tag?: string
  headline?: PortableTextObject
  content?: PortableTextObject
  displayForm?: boolean
  labelBtn?: string
  titleForm?: string
  checkboxText?: string
	_key: string
	downloadInfo: {
		title: string
		fileUrl: string
		fileName: string
		tag: string
	}
}

export const SingleImage: React.FC<SingleImageProps> = ({
	_key,
  image,
  displayText,
  tag,
  headline,
  content,
  displayForm,
  labelBtn,
	downloadInfo
}) => {
  let [isOpen, setIsOpen] = useState(false)
  const pathname = usePathname();

  const contentComponent = {
    block: {
      normal: ({children}: any) => {
        return (
          <AppText as="p" weight='medium' size='base'>
            {children}
          </AppText>
        )
      }
    },
    marks: {
      highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
    }
  } as PortableTextComponents

  const { base, imageStyle, contentContainer, contentStyle } = styles()

  return (
    <section className={base()} style={{ position: 'relative' }}>
      <SanityImage
        image={image.image}
        alt={image.alt || ''}
        className={imageStyle()}
        sizes='(max-width: 768px) 80vw, (max-width: 1200px) 50vw, 80vw'
      />
      {/* Hardcoded Centered Headline Overlay - only on /impact */}
      {pathname === '/impact' && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            textAlign: 'center',
            zIndex: 2,
            pointerEvents: 'none',
          }}
        >
          <span
            style={{
              fontFamily: 'var(--font-helvetica-neue-condensed)',
              fontWeight: 500,
              color: '#fff',
              fontSize: '70px',
              lineHeight: '1',
              letterSpacing: '0.02em',
              display: 'inline-block',
            }}
          >
            AGRO-WASTE INTO SAFE <br /> AND SUSTAINABLE SOLUTIONS
          </span>
        </div>
      )}
      {/* End Hardcoded Centered Headline Overlay */}
      {displayText && (
        <div className={contentContainer()}>
					<SectionHeader tag={tag} title={headline as any} noPx fullWidth />
					<div className={contentStyle()}>
						{content && <PortableText value={content} components={contentComponent} />}
					</div>

					{/* TODO - Replace download form with proper component */}
					{displayForm && (
            <>
              <Button className='mt-2 inline-flex items-center' iconRight={<DownloadIcon className='w-1 h-1'/>} onClick={() => setIsOpen(true)} arrow={false}>{labelBtn}</Button>
              <PopupForm _key={_key} downloadInfo={downloadInfo} isOpen={isOpen} setIsOpen={setIsOpen} />
            </>
          )}
        </div>
      )}
    </section>
  )
}
